import SelectField from '@pages/Admin/CourseSettings/components/SelectField/SelectField'
import s from './modalBody.module.css'
import Range from '../../UI/Range'
import Button from '../../UI/Button'
import { useMemo, useState } from 'react'
import { convertNumberCost } from '../../../helpers/convertNumberCost'
import { directionOrdersApi } from '../../../api'
// import { useInputNew } from '../../UI/InputNew/useInputNew'
import { InputNew } from '../../UI/InputNew'
import { useGetId } from '@/hooks/useGetId'
import { useAddAlert } from '@/hooks/useAddAlert'
import SecondaryButton from '@pages/Admin/CourseSettings/components/SecondaryButton/SecondaryButton'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import TextField from '@pages/Admin/CourseSettings/components/TextField/TextField'
import SliderField from '@pages/Admin/CourseSettings/components/SliderField/SliderField'
import { useSelector } from 'react-redux'
import PromoCodeField from '@pages/CoursesCatalog/modals/CourseEnrollmentModal/components/PromoCodeField/PromoCodeField'
import { getPriceWithDiscount } from '@pages/CoursesCatalog/modals/CourseEnrollmentModal/utils/tariff'

const getDiscountedAmount = (sum, discount, type = 'р') => {
  if (type === '%') return Number((sum - (sum * discount) / 100).toFixed(2))
  return sum - discount
}

const ModalBody = ({
  type,
  data,
  setModal,
  order,
  isPaymentWithoutRegistration = false,
  paymentChildrenId = null
}) => {
  const addAlert = useAddAlert()
  const childrenId = useGetId()
  const [valRange, setValRange] = useState(1)
  const [valNumber, setValNumber] = useState(1)
  const [selectedPeriodId, setSelectedPeriodId] = useState(null)
  const [isSaving, setIsSaving] = useState(false)

  let title = null
  let privatePrice = null
  let summ = null

  const isPromoEnabled = useSelector((store) => {
    return store.settings.isPromocodeEnabledForRenewal === '1'
  })
  const [discount, setDiscount] = useState(null)

  const tariffPeriods =
    data?.tariff?.type === 'stream_custom_period'
      ? data?.tariff?.tariffPeriods ?? []
      : data?.tariff?.type === 'stream_custom_days'
      ? data?.tariff?.tariffDays ?? []
      : data?.tariff?.tariffWeeks ?? []

  const { price, priceWithDiscount } = useMemo(() => {
    let privatePrice = 0
    let summ = 0
    switch (type) {
      case 'private':
        privatePrice = data?.privateInfo?.hour_cost
          ? Number(data.privateInfo.hour_cost)
          : data.tariff.first_price
        summ = valNumber * privatePrice
        break
      case 'group':
        privatePrice = order?.privateInfo?.hour_cost
          ? Number(order.privateInfo.hour_cost)
          : data.tariff.first_price
        summ = valRange * data.tariff.first_price
        break
      case 'class':
        title = `Продлить обучение ${data?.title}`
        privatePrice = data.payment_amount
        summ = valRange * data.payment_amount
        break
      default:
        break
    }
    if (
      [
        'stream_custom_period',
        'stream_custom_days',
        'stream_custom_weeks',
      ]?.includes(data?.tariff?.type)
    ) {
      summ =
        tariffPeriods?.find((item) => item?.id === selectedPeriodId)?.price ?? 0
    }

    return {
      price: summ,
      priceWithDiscount: getPriceWithDiscount(
        summ - (data?.discount ?? 0) ?? 0,
        discount,
      ),
    }
  }, [valNumber, valRange, selectedPeriodId, discount])

  const payment = async () => {
    setIsSaving(true)
    let newData = {}
    newData.amount = priceWithDiscount
    if (isPaymentWithoutRegistration)
      newData.user_id = paymentChildrenId

    // Для кастомных тарифов: id периода обязательно, остальное не нужно
    if (
      [
        'stream_custom_period',
        'stream_custom_days',
        'stream_custom_weeks',
      ].includes(data?.tariff?.type)
    ) {
      if (selectedPeriodId === null) {
        addAlert({ text: 'Нужно выбрать период!', type: 'error' })
        setIsSaving(false)
        return
      }
      newData.order_id = data.id
      newData.selected_period_id = selectedPeriodId

      if (data?.tariff?.type === 'stream_custom_days') {
        newData.buy_days = tariffPeriods.find(
          (item) => item?.id === selectedPeriodId,
        )?.days
      }
      if (data?.tariff?.type === 'stream_custom_period') {
        newData.buy_months = tariffPeriods.find(
          (item) => item?.id === selectedPeriodId,
        )?.months
      }
      if (data?.tariff?.type === 'stream_custom_weeks') {
        newData.buy_weeks = tariffPeriods.find(
          (item) => item?.id === selectedPeriodId,
        )?.weeks
      }
    } else if (type === 'private') {
      newData.order_id = data.id
      newData.buy_hour = valNumber
    } else if (type === 'group') {
      newData.order_id = data.id
      newData.buy_months = valRange
    } else if (type === 'class') {
      newData.class_id = data.id
      newData.buy_months = valRange
      newData.user_id = isPaymentWithoutRegistration ?
        paymentChildrenId : childrenId
    }

    let res = null

    try {
      if (type === 'class') {
        res = await directionOrdersApi.extendClass({
          data: newData,
        })
      } else {
        let orderType = ''

        if (data?.tariff?.type === 'stream_custom_days') {
          orderType = 'student-day'
          newData.buy_days = tariffPeriods?.find(
            (item) => item?.id === selectedPeriodId,
          )?.days
        } else if (data?.tariff?.type === 'stream_custom_period') {
          orderType = 'student-month'
          newData.buy_months = tariffPeriods?.find(
            (item) => item?.id === selectedPeriodId,
          )?.months
        } else if (data?.tariff?.type === 'stream_custom_weeks') {
          orderType = 'student-week'
          newData.buy_weeks = tariffPeriods?.find(
            (item) => item?.id === selectedPeriodId,
          )?.weeks
        } else {
          orderType = type === 'private' ? 'student-hour' : 'student-month'
        }

        res = await directionOrdersApi.extend({
          data: newData,
          params: { type: orderType },
        })
      }

      if (res.data.payment_link) {
        setModal({
          active: true,
          type: 'redirectBank',
          data: newData,
          order: res.data,
        })
      }

      window.open(res.data.payment_link)
    } catch (error) {
    } finally {
      setIsSaving(false)
    }
  }

  const [addOrders, setOrders] = useState([])
  const [addedCourses, setAddedCourses] = useState([])

  const changeAddedCourse = (order_id, data) => {
    setOrders(
      addOrders.map((item) =>
        item.id === order_id ? { ...item, ...data } : item,
      ),
    )
  }

  const removeAddedCourse = (order_id) => {
    setAddedCourses(addedCourses.filter((id) => id !== order_id))
    setOrders(addOrders.filter((item) => item.id !== order_id))
  }

  let totalOld = price
  let total = price

  addOrders?.forEach((order, i) => {
    totalOld = totalOld + order.price
    total += getDiscountedAmount(order.price, i > 0 ? 8 : 6, '%')
  })

  if (process.env.REACT_APP_BLOCK_PAYMENT === '1')
    return (
      <>
        <h2 className="modal__title">Продлить обучение</h2>

        <p style={{ marginBottom: 20 }}>
          Чтобы продолжить обучение, Вам необходимо продлить курс.
        </p>

        <div className={s.wrap} style={{ marginBottom: 20 }}>
          Прости, данный функционал ещё на стадии разработки
        </div>

        <Button
          name="Закрыть"
          action={() => setModal({ active: false })}
          styles="accent"
        />
      </>
    )

  const tariffPeriodsOptions = tariffPeriods?.map((item) => {
    return {
      value: item?.id,
      label:
        data?.tariff?.type === 'stream_custom_period'
          ? item?.months
          : data?.tariff?.type === 'stream_custom_days'
          ? item?.days
          : item?.weeks,
    }
  })

  return (
    <div className={s.wrapper}>
      <h2 className={s.title}>{title}</h2>
      <div className={s.description}>
        Если Вы хотите произвести оплату за несколько месяцев/часов, то
        производить её нужно одним платежом (или через 20 минут после первой
        оплаты)
      </div>
      <br />
      {![
        'stream_custom_period',
        'stream_custom_days',
        'stream_custom_weeks',
      ]?.includes(data?.tariff?.type) ? (
        data?.tariff?.type === 'month' ||
        type === 'group' ||
        type === 'class' ? (
          <SliderField
            label="Выберите количество месяцев"
            value={valRange}
            min={1}
            max={18}
            onChange={(value) => setValRange(value)}
          />
        ) : (
          <>
            <div className={s.cost}>
              Стоимость 1 {data?.tariff?.type === 'hour' ? 'часа' : 'минуты'} -{' '}
              {convertNumberCost(privatePrice)} руб
            </div>
            <TextField
              label={`Введите количество ${
                data?.tariff?.type === 'hour' ? 'часов' : 'минут'
              }, которые вы хотите оплатить`}
              className={s.input}
              value={valNumber}
              placeholder="5.5"
              onChange={(e) => {
                const value = e.replace(/[^.\d]/g, '')
                var from = value.indexOf('.') + 1
                const newValue = from ? value.slice(0, from + 2) : value
                setValNumber(newValue)
              }}
            />
          </>
        )
      ) : (
        <></>
      )}
      {[
        'stream_custom_period',
        'stream_custom_days',
        'stream_custom_weeks',
      ]?.includes(data?.tariff?.type) && (
        <SelectField
          className={s.select}
          wrapperClassName={s.marginTop}
          label={
            data?.tariff?.type === 'stream_custom_period'
              ? 'Количество месяцев'
              : data?.tariff?.type === 'stream_custom_days'
              ? 'Количество дней'
              : data?.tariff?.weekly_tariff_text_type == 1
              ? 'Количество занятий'
              : 'Количество недель'
          }
          placeholder={
            data?.tariff?.type === 'stream_custom_period'
              ? 'выберите кол-во месяцев'
              : data?.tariff?.type === 'stream_custom_days'
              ? 'выберите кол-во дней'
              : data?.tariff?.weekly_tariff_text_type == 1
              ? 'выберите кол-во зянятий'
              : 'выберите кол-во недель'
          }
          value={selectedPeriodId}
          onChange={(e) => {
            setSelectedPeriodId(e)
          }}
          // @ts-ignore
          options={tariffPeriodsOptions}
        />
      )}
      {addedCourses.length > 0 && (
        <div className={s.addedList}>
          {addOrders.map((item) => (
            <AddedItem
              {...{
                key: item.id,
                ...item,
                changeAddedCourse,
                removeAddedCourse,
              }}
            />
          ))}
        </div>
      )}
      {addOrders.length > 0 && (
        <div className={s.orderSum}>
          <h4 className={s.addedName}>
            {data?.direction?.name}: {convertNumberCost(summ)} р{' '}
          </h4>
          {addOrders?.map((order, i) => (
            <h4 key={order.id} className={s.addedName}>
              {order.order.direction.name}:{' '}
              {convertNumberCost(
                getDiscountedAmount(order.price, i > 0 ? 8 : 6, '%'),
              )}
              р{' '}
              <span className={s.oldPrice}>
                {convertNumberCost(order.price)}р
              </span>
            </h4>
          ))}
        </div>
      )}
      {isPromoEnabled && (
        <div className={s.promoWrapper}>
          <PromoCodeField
            userId={childrenId}
            code={discount}
            setCode={setDiscount}
          />
        </div>
      )}
      <div className={s.footer}>
        <span className={s.sum}>
          Итого: {convertNumberCost(priceWithDiscount)} р{' '}
          {addOrders?.length > 0 && (
            <span className={s.oldPrice}>{convertNumberCost(totalOld)}р</span>
          )}
          {(!!discount || !!data?.discount) && !!price && (
            <span className={s.oldSum}>{convertNumberCost(price)}р</span>
          )}
        </span>
        {isSaving && (
          <Spin
            indicator={
              <LoadingOutlined
                spin
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            }
          />
        )}
        <SecondaryButton
          className={s.button}
          styles={{ minWidth: '140px', justifyContent: 'center' }}
          onClick={payment}
          disabled={isSaving}
        >
          Купить
        </SecondaryButton>
      </div>
    </div>
  )
}

export default ModalBody

const AddedItem = ({
  order,
  value,
  price,
  changeAddedCourse,
  removeAddedCourse,
}) => {
  const onChange = (event) => {
    const value = Number(event.target.value.replace(/[^\d]/g, ''))
    changeAddedCourse(order.id, {
      value,
      price: value * order.tariff.first_price,
    })
  }

  return (
    <div className={s.AddedItem}>
      <button
        className={`close ${s.close}`}
        onClick={() => removeAddedCourse(order.id)}
      ></button>

      <h3 className={s.addedCoursesName}>{order.direction.name}</h3>
      {order.tariff.type === 'month' ? (
        <>
          <p className={s.descr}>Выберите количество месяцев</p>
          <Range max={18} min={1} value={value} onChange={onChange} />
        </>
      ) : (
        <>
          <p className={s.descr}>
            Введите количество часов, которые вы хотите оплатить
          </p>
          <InputNew value={value} onChange={onChange} />
        </>
      )}
    </div>
  )
}
